import React from 'react';
import { updatedata } from '../../util/global';

interface props {
  showmodal: string;
  setshowmodal: (modal: string) => void;
  formdata: any;
  setformdata: (data: any) => void;
  fetchdata: () => void;
}

const AdminSubscriptionForm: React.FC<props> = ({
  showmodal,
  setshowmodal,
  formdata,
  setformdata,
  fetchdata
}) => {
  if (showmodal !== 'showsubscriptionform') return null;

  const handlesave = async () => {
    const payload = {
      data: {
        ...formdata,
        datatype: 'subscriptiondata'
      }
    };
    await updatedata(payload);
    setshowmodal('');
    fetchdata();
  };

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <div className="modal-header">
          <h3>edit subscription</h3>
          <button className="close-btn" onClick={() => setshowmodal('')}>&times;</button>
        </div>
        <div className="modal-body">
          <div className="form-group">
            <label>end date</label>
            <input
              type="date"
              className="form-input"
              placeholder="yyyy-mm-dd"
              value={formdata.enddate ? formdata.enddate.split('T')[0] : ''}
              onChange={(e) => setformdata({ ...formdata, enddate: e.target.value })}
            />
          </div>

          <button className="btn-blue full-width" onClick={handlesave}>
            save subscription
          </button>
        </div>
      </div>
    </div>
  );
};

export default AdminSubscriptionForm;
